import { FC } from "react";
import AccordionButton from "../../../assets/icon/AccordionButton";
import ActiveAccordionButton from "../../../assets/icon/ActiveAccordionButton";
import Quill from "../../common/quill/Quill";

type Props = {
  isOpen: boolean;
  title: string;
  content: string;
  onClick: () => void;
};

const AccordionItem: FC<Props> = ({ title, content, isOpen, onClick }) => {
  return (
    <div className="flex flex-col justify-center items-stretch text-base px-1 ">
      <div className="shadow-sm cursor-pointer bg-white" onClick={onClick}>
        <div className="text-left items-center h-12 select-none flex justify-between flex-row">
          <h5
            className={!isOpen ? "font-semibold" : "font-semibold text-orange"}
          >
            {title}
          </h5>
          <div className="flex-none pl-2">
            {isOpen ? <ActiveAccordionButton /> : <AccordionButton />}
          </div>
        </div>
        <div
          className={`pt-0 overflow-auto touch-auto transition-[max-height] duration-200 ease-in ${
            isOpen ? "max-h-auto" : "max-h-0"
          }`}
        >
          <p className="pb-4 pt-3 text-[15px] opacity-90 text-left">
            <Quill text={content} className={"accordion"} />
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;
